/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the RemovePushSubscriptionRequest interface.
 */
export function instanceOfRemovePushSubscriptionRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function RemovePushSubscriptionRequestFromJSON(json) {
    return RemovePushSubscriptionRequestFromJSONTyped(json, false);
}
export function RemovePushSubscriptionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
    };
}
export function RemovePushSubscriptionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'endpoint': value.endpoint,
    };
}
